module.exports = __webpack_public_path__ + "static/unique-online-store@2x-44ca34c3222bfd17b8ccdfb61fc8f0f7.png";